"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ramda = require("ramda");
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireWildcard(require("../../../../../../../ui/Button"));
var _withProps = _interopRequireDefault(require("../../../../../Offer/Buttons/components/BookingButton/withProps"));
var _arrowIcon = _interopRequireDefault(require("./img/arrowIcon.svg"));
var _styles = _interopRequireDefault(require("./styles.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var DefaultBookingButton = function DefaultBookingButton(_ref) {
  var loading = _ref.loading,
    onClick = _ref.onClick;
  var _useTranslation = (0, _reactI18next.useTranslation)('OFFER_DETAILS'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    iconClassName: _styles.default.icon,
    icon: _arrowIcon.default,
    width: _Button.WIDTHS.FLUID,
    fontFamily: _Button.FONT_FAMILIES.REGULAR,
    theme: _Button.THEMES.GRAY,
    onClick: loading ? undefined : onClick
  }, t('DEFAULT_BOOKING_BUTTON'));
};
DefaultBookingButton.propTypes = {
  onClick: _propTypes.default.func.isRequired,
  loading: _propTypes.default.bool
};
var enhancer = (0, _ramda.compose)(_withProps.default, _react.memo);
var _default = exports.default = enhancer(DefaultBookingButton);